// Campus photo for /colleges/university-of-montana: CC BY 2.0, by Jitze Couperus, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUniversity_Hall_-_University_of_Montana.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-montana/; credited under the photo.
const photo = {
    "slug": "university-of-montana",
    "alt": "University Hall and its clock tower at the end of the Oval walkway, with Mount Sentinel behind, at the University of Montana in Missoula",
    "src": "/colleges/university-of-montana/campus-1600.webp",
    "srcSmall": "/colleges/university-of-montana/campus-800.webp",
    "srcMid": "/colleges/university-of-montana/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-montana/og.jpg",
    "title": "University Hall - University of Montana",
    "author": "Jitze Couperus",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUniversity_Hall_-_University_of_Montana.jpg",
    "read": "2026-10-01"
};

export default photo;
